<template>
  <div class="container_left" :style="{ width: left_bar_show_state ? '300px' : '64px' }">
    <!-- 左侧栏主内容 -->
    <div v-if="left_bar_show_state" class="left_bar_main" style="position: relative; height: 100vh; min-width: 300px; max-width: 300px; box-sizing: border-box; background: #f7f9fc; display: flex; flex-direction: column; overflow: hidden; box-shadow: 1px 0 0 rgba(15, 23, 42, 0.08)">
      <div class="sidebar_scroll" style="padding: 0 20px">
        <!-- 顶部Logo和折叠按钮 -->
        <div class="top_header">
          <div class="logo_area" @click="goToLiteratureSearch">
            <img v-if="showCxstarLogo" src="@/assets/cxstar.png" alt="畅想之星" class="logo_img" />
            <span class="logo_text">{{ login_org_sys_name }}</span>
          </div>

          <i class="fold_icon el-icon-s-fold" @click="hide_show_left_bar"></i>
        </div>

        <!-- 用户机构信息 -->
        <div v-if="user_last_login_org" class="user_org_info">
          <!-- <i class="el-icon-office-building"></i> -->
          欢迎来自<span>{{ user_last_login_org }}</span
          >的朋友
        </div>

        <!-- 新话题按钮 -->
        <div @click="startAcademicSearchConversation(true)" class="new_conv">
          <i class="el-icon-edit-outline"></i>
          <span>新话题</span>
        </div>

        <!-- 科学导航折叠面板 -->
        <el-collapse class="my_collapse xk_collapse" v-model="activeNames">
          <el-collapse-item name="1">
            <template #title>
              <i class="el-icon-cpu collapse_icon"></i>
              <span class="collapse_title">科学导航</span>
            </template>
            <div v-for="(sic_nav, idx) in sic_nav_list" :key="idx" :class="['tool_btn mtop5', selected_nav_index === idx ? 'tool_btn_checked' : '']" @click="jumpToUrl(sic_nav['url'], idx)">
              <span>{{ sic_nav.url === "/subjectGateway/index" && scholarlyServiceEnabled ? "学科服务平台" : sic_nav.name }}</span>
            </div>
          </el-collapse-item>
        </el-collapse>

        <!-- 工具按钮列表 -->
        <div class="tools_section">
          <div v-for="(tool, idx) in tool_list" :key="idx">
            <div v-if="!tool['disabled']" :class="['tool_btn', cur_tool_idx === idx ? 'tool_btn_checked' : '']" :tabindex="idx" @click="handleTool(idx, tool_list)">
              <i :class="tool.icon"></i>
              <span class="tool_name">{{ tool.name }}</span>
            </div>
            <div v-if="tool.name === '资源助手'" class="tool_btn zotero_tool_btn" @click="openZoteroBoard">
              <i class="el-icon-connection"></i>
              <span class="tool_name">Zotero扩展版</span>
            </div>
          </div>
        </div>

        <!-- 历史记录折叠面板 -->
        <el-collapse class="my_collapse history_collapse" v-model="activeNames">
          <el-collapse-item name="2">
            <template #title>
              <i class="el-icon-timer collapse_icon"></i>
              <span class="collapse_title">历史记录</span>
            </template>
            <div class="chat_history_content" v-if="conversation_history.length > 0">
              <div v-for="(conv, idx) in conversation_history" :class="conv['conversation_id'] == cur_conversation_id ? 'label_checked' : 'common_label'" :key="idx" @click="history_conversation(conv, tool_list)" title="">
                <span v-show="conv['type']" class="conv_span">{{ conversationTypeLabel(conv) }}</span>
                <label :title="conv['conversation_name']">{{ conv["conversation_name"] }}</label>
              </div>
            </div>
            <div v-else class="empty_history">
              <i class="el-icon-chat-line-round"></i>
              <span>暂无历史搜索</span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div class="bottom_section">
        <!-- 底部用户信息区域 -->
        <!-- 退出和 IP 登录 -->
        <div class="loginManager" v-if="jyx_token">
          <div class="flex line1" @click="tomyHome">
            <i class="el-icon-s-custom"></i>
            <span class="loginName">
              <label class="line1">{{ user_display_name }}</label>
              <label v-if="ipFlag == 1">(IP用户)</label>
            </span>
          </div>

          <div class="login_setting" v-if="ipFlag != 1 && jyx_token">
            <div class="logout_img outlogin" title="退出登录" @click="logout">
              <img src="../assets/icon-tc-mr.png" alt="" />
              <img src="../assets/icon-tc-xz.png" alt="" />
            </div>
          </div>
          <div class="login_setting" v-if="ipFlag == 1">
            <div class="logout_img outlogin" title="去登录" @click="tomyHome">
              <el-button type="primary" size="mini">登录</el-button>
            </div>
          </div>
        </div>
        <!-- 未登录状态 -->
        <div class="loginManager" v-if="!jyx_token">
          <el-button type="primary" style="width: 100%; margin-top: 20px" @click="tomyHome">登录</el-button>
        </div>
      </div>
      <!-- 联系方式 -->
      <div class="contact_link" @click="$router.push('/Contact').catch(() => {})">
        <i class="el-icon-service"></i>
        <span>联系我们</span>
      </div>
    </div>

    <!-- 折叠状态下的迷你侧边栏 -->
    <!-- <div v-show="!left_bar_show_state" class="mini_sidebar">
      <div class="mini_header">
        <i class="unfold_icon el-icon-s-unfold" @click="hide_show_left_bar"></i>
        <div @click="add_conversation(null, tool_list)" class="new_conv2">
          <i class="el-icon-edit-outline"></i>
          新话题
        </div>
      </div>
    </div> -->
    <!-- 折叠后显示的图标 -->
    <div v-show="!left_bar_show_state" class="mini_sidebar">
      <div class="mini_sidebar_content">
        <div class="mini_logo" @click="goToLiteratureSearch">
          <img v-if="showCxstarLogo" src="@/assets/cxstar.png" alt="畅想之星" class="mini_logo_img" />
        </div>

        <div class="mini_icon_list">
          <div class="mini_icon_item" @click="hide_show_left_bar">
            <div class="mini_icon_wrapper">
              <el-tooltip class="item" effect="dark" content="展开" placement="right"><i class="el-icon-s-unfold"></i></el-tooltip>
            </div>
            <span class="mini_tooltip">展开菜单</span>
          </div>
          <div class="mini_icon_item" @click="startAcademicSearchConversation(true)">
            <div class="mini_icon_wrapper">
              <el-tooltip class="item" effect="dark" content="新话题" placement="right">
                <i class="el-icon-edit-outline"></i>
              </el-tooltip>
            </div>
            <span class="mini_tooltip">新话题</span>
          </div>

          <div class="mini_divider"></div>

          <div v-for="(tool, idx) in tool_list" :key="idx">
            <div v-if="!tool['disabled']" class="mini_icon_item" @click="handleTool(idx, tool_list)">
              <div class="mini_icon_wrapper">
                <el-tooltip class="item" effect="dark" :content="tool.name" placement="right">
                  <i :class="tool.icon"></i>
                </el-tooltip>
              </div>
              <span class="mini_tooltip">{{ tool.name }}</span>
            </div>
            <div v-if="tool.name === '资源助手'" class="mini_icon_item" @click="openZoteroBoard">
              <div class="mini_icon_wrapper">
                <el-tooltip class="item" effect="dark" content="Zotero扩展版" placement="right">
                  <i class="el-icon-connection"></i>
                </el-tooltip>
              </div>
              <span class="mini_tooltip">Zotero扩展版</span>
            </div>
          </div>
        </div>

        <div class="mini_user_section">
          <div class="mini_icon_item" @click="tomyHome">
            <div class="mini_icon_wrapper mini_avatar">
              <div class="header">
                <UserAvatar v-if="user_display_name" :user_display_name="user_display_name" :size="40" class="user_avatar" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 文献分析页 -->
    <div style="position: fixed; top: 0; left: 0; width: 100%; z-index: 999; overflow-y: auto; height: 100vh" :class="analysis_table_show_state ? 'slow_show' : 'slow_hide'">
      <FullTxtArtAnalysisTip @clossPaperAnalysis="clossPaperAnalysis" :full_txt_art_analysis_data="full_txt_art_analysis_data"></FullTxtArtAnalysisTip>
    </div>
  </div>
</template>

<script>
import UserAvatar from "../components/UserAvatar.vue";
import EventBus from "../eventBus/EventBus.js";
import { getOrgUrlInstance } from "../utils/authUtils";
import { encryptUserInfo } from "../utils/ssoEncryptor.js";
import { clearAllAuthTokens, clearMicroToken, getAuthSessionVersion, getMainToken, getMicroToken, getUserDisplayName, setIpUserFlag, setMainToken, setMicroToken, setUserDisplayName } from "../utils/authSession";

const LOGIN_ORG_SYS_NAME_CACHE_KEY = "login_org_sys_name";
const DEFAULT_LOGIN_ORG_SYS_NAME = "畅想之星简易寻";

export default {
  name: "LeftBar",
  // props: {
  //   user_id: {
  //     type: String,
  //     required: true,
  //     // default: () => ([])
  //   }
  // },
  components: {
    FullTxtArtAnalysisTip: () => import("./FullTxtArtAnalysisResultWorkBench.vue"),
    UserAvatar,
  },
  data() {
    return {
      // 左侧工具栏是否显示
      left_bar_show_state: true,
      // 侧边 tab 页显示哪个
      activeName: "conversation_history",
      // 会话历史列表
      conversation_history: [],
      // 当前选择的会话 ID
      cur_conversation_id: null,
      // 默认会话正在创建中的闩，防止 LeftBar 和 Home 同时触发建出两个会话
      default_conversation_pending: false,
      // 功能列表
      tool_list: [],
      // 当前选择的工具
      cur_tool_idx: null,

      // 论文分析结果相关
      analysis_table_show_state: false,
      full_txt_art_analysis_data: null,

      // 手风琴当前展开哪些
      activeNames: ["1"],

      // 统一认证工具类实例
      authUtils: getOrgUrlInstance(this.$http),

      // 科学导航
      // 线上
      // 演示环境
      sic_nav_list: [
        { name: "期刊导航", url: "/home" },
        { name: "学科知识库", url: "/subjectGateway/index" },
        { name: "学者库", url: "/author" },
        { name: "文献服务平台", url: "/asp/" },
      ],

      // 当前选中的科学导航索引
      selected_nav_index: -1,

      user_display_name: null,
      user_last_login_org: null,
      login_org_sys_name: localStorage.getItem(LOGIN_ORG_SYS_NAME_CACHE_KEY) || DEFAULT_LOGIN_ORG_SYS_NAME,
      loginOrgSysNamePromise: null,
      loginOrgInfoLoaded: false,
      trialStatus: null,
      schoolCode: "",
      loginOrgSysNameRequestId: 0,
      orgUrl: "",
      ipFlag: 0,
      jyx_token: "",
      microAppTokenPromise: null,
      mainSidebarDataLoaded: false,
      isRefreshingToken: false,
      updateUserInfoHandler: null,
      routeSyncHandler: null,
    };
  },
  props: {
    userName: {
      type: String,
      default: "",
    },
    avater: {
      type: String,
      default: "",
    },
  },
  computed: {
    scholarlyServiceEnabled() {
      return this.trialStatus === true || !!(this.trialStatus && this.trialStatus.data === true && (this.trialStatus.code === undefined || this.trialStatus.code === 1));
    },
    showCxstarLogo() {
      return String(this.login_org_sys_name || "").includes("畅想之星");
    },
  },
  watch: {
    userName: {
      handler(newVal) {
        if (newVal) {
          this.user_display_name = newVal;
        }
      },
      immediate: true,
    },
    // 之前可能监听了 $route，如果里面调用了 getUserInfo 或其他初始化请求，会导致子应用跳转时主应用刷新
    // 所以如果原来有对 $route 的监听，需要避免它在子应用内部跳转时重复触发请求
    $route(newVal) {
      const path = newVal && newVal.path ? newVal.path : window.location.pathname;
      this.syncToolSelection(path);
      this.syncSelectedNavIndex(path);
    },
    tool_list() {
      const path = this.$route && this.$route.path ? this.$route.path : window.location.pathname;
      this.syncToolSelection(path);
      this.syncSelectedNavIndex(path);
    },
  },
  mounted() {
    // 检查是否为移动端或 iPad（宽度小于等于 1024px 通常认为是平板/手机）
    this.checkIfMobile();

    const currentPath = window.location.pathname;
    if (!this.isMainAppRoute(currentPath)) {
      this.ensureMicroAppTokenReady({
        forceRefresh: currentPath === "/asp/self_setting",
      }).then(() => {
        this.loadMainSidebarData();
      });
    } else if (localStorage.getItem("token")) {
      this.getUserInfo();
    } else {
      this.getIPUser();
    }

    // 监听子应用发来的更新消息
    this.updateUserInfoHandler = e => {
      if (e.data.type === "UPDATE_USER_INFO") {
        this.handleMessage(e.data);
      }
    };
    window.addEventListener("message", this.updateUserInfoHandler);

    // 把刷新 token 的方法挂载到全局，让子应用在 401 时能调用
    window.refreshToken = this.refreshToken.bind(this);

    this.syncToolSelection(window.location.pathname);
    this.syncSelectedNavIndex(window.location.pathname);
    this.routeSyncHandler = () => {
      this.syncToolSelection(window.location.pathname);
      this.syncSelectedNavIndex(window.location.pathname);
    };
    window.addEventListener("popstate", this.routeSyncHandler);
    window.addEventListener("hashchange", this.routeSyncHandler);
  },
  // 在 beforeDestroy 生命周期中移除监听
  beforeDestroy() {
    if (this.updateUserInfoHandler) {
      window.removeEventListener("message", this.updateUserInfoHandler);
    }
    if (window.refreshToken) {
      delete window.refreshToken;
    }
    if (this.routeSyncHandler) {
      window.removeEventListener("popstate", this.routeSyncHandler);
      window.removeEventListener("hashchange", this.routeSyncHandler);
    }
  },
  methods: {
    getStoredSelectedToolFunction() {
      return sessionStorage.getItem("leftbar_selected_tool_function");
    },
    // 历史记录里的类型标签：走 RAG 的会话后端回传的是英文 function 名(academic_search)，
    // 老会话回传的已经是中文标签，这里统一按 tool_list 映射成中文名；映射不到就原样显示，
    // 避免因为多了个新工具就变成空标签。
    conversationTypeLabel(conv) {
      const type = conv && conv["type"];
      if (!type) return "";
      const matched = Array.isArray(this.tool_list) ? this.tool_list.find(tool => tool && tool["function"] === type) : null;
      return matched && matched["name"] ? matched["name"] : type;
    },
    getAcademicSearchToolIndex(toolList = this.tool_list) {
      if (!Array.isArray(toolList)) {
        return -1;
      }
      return toolList.findIndex(tool => tool && tool["function"] === "academic_search");
    },
    startAcademicSearchConversation(shouldClearTopicAssistantCache = false) {
      const academicSearchToolIndex = this.getAcademicSearchToolIndex();
      if (academicSearchToolIndex === -1) {
        return;
      }
      this.handleTool(academicSearchToolIndex, this.tool_list, shouldClearTopicAssistantCache);
    },
    setStoredSelectedToolFunction(toolFunction) {
      if (toolFunction) {
        sessionStorage.setItem("leftbar_selected_tool_function", toolFunction);
      } else {
        sessionStorage.removeItem("leftbar_selected_tool_function");
      }
    },
    isMainAppRoute(path) {
      return path === "/ai_home" || path === "/topic-assistant" || path === "/oauth_loading" || path === "/casiLoading" || path === "/Contact" || path === "/topic_assistant_result" || path === "/topic_assistant_result_ifram" || path === "/full_txt_art_analysis_result";
    },
    getToolFunctionByPath(path) {
      if (path === "/ai_home") {
        return "academic_search";
      }
      if (path === "/topic-assistant") {
        return this.getStoredSelectedToolFunction() || "topic_selection_assistance";
      }
      const search = window.location.search || "";
      if (path === "/asp" || path === "/asp/") {
        const params = new URLSearchParams(search);
        const index = params.get("index");
        if (index === "4") {
          return "literature_review";
        }
        if (index === "5") {
          return "pdf_translation";
        }
        return null;
      }
      const toolFunctionByPath = {
        "/": "academic_search",
        "/literatureSearch": "word_segment_search",
        "/article": "word_segment_search",
        "/asp/literature_analysis": "full_txt_art_analysis",
        "/full_txt_art_analysis_result": "full_txt_art_analysis",
        "/topic-assistant": "topic_selection_assistance",
        "/asp/literature_review": "literature_review",
        "/topic_assistant_result": "topic_selection_assistance",
        "/topic_assistant_result_ifram": "topic_selection_assistance",
        "/asp/translation": "pdf_translation",
        "/AiHelp": "ai_help",
      };
      return toolFunctionByPath[path] || null;
    },
    isJournalNavRoute(path) {
      if (!path) {
        return false;
      }
      return path === "/home" || path === "/homeDetail" || path === "/articleDetail";
    },
    syncSelectedNavIndex(path) {
      if (!path || this.getToolFunctionByPath(path) || this.isMainAppRoute(path)) {
        this.selected_nav_index = -1;
        return;
      }
      if (path.startsWith("/subjectGateway")) {
        this.selected_nav_index = 1;
        return;
      }
      if (path.startsWith("/author")) {
        this.selected_nav_index = 2;
        return;
      }
      if (path.startsWith("/asp")) {
        this.selected_nav_index = 3;
        return;
      }
      if (this.isJournalNavRoute(path)) {
        this.selected_nav_index = 0;
        return;
      }
      this.selected_nav_index = -1;
    },
    syncToolSelection(path) {
      const matchedFunction = this.getToolFunctionByPath(path);
      const storedToolFunction = this.getStoredSelectedToolFunction();
      const effectiveFunction = matchedFunction || (!this.isJournalNavRoute(path) && !path.startsWith("/subjectGateway") && !path.startsWith("/author") ? storedToolFunction : null);
      if (!effectiveFunction) {
        this.cur_tool_idx = null;
        return;
      }
      const matchedIndex = this.tool_list.findIndex(tool => tool && tool["function"] === effectiveFunction);
      this.cur_tool_idx = matchedIndex >= 0 ? matchedIndex : null;
    },
    resetAllPossibleScrollTops() {
      const elements = [
        document.getElementById("subapp-container"),
        document.querySelector(".micro-app-container"),
        document.querySelector("#app"),
        document.querySelector("#app .wrapper"),
        document.querySelector("#app .view"),
        document.querySelector(".view"),
        document.scrollingElement,
        document.documentElement,
        document.body,
      ].filter(Boolean);

      const uniqueElements = elements.filter((element, index) => elements.indexOf(element) === index);
      uniqueElements.forEach(element => {
        element.scrollTop = 0;
      });
      window.scrollTo(0, 0);
    },
    scheduleResetAllPossibleScrollTops() {
      [0, 50, 150, 300, 500].forEach(delay => {
        setTimeout(() => {
          this.resetAllPossibleScrollTops();
        }, delay);
      });
    },
    clearTopicAssistantSessionCache() {
      ["topic_assistant_form", "topic_assistant_back_context", "topic_assistant_result", "topic_assistant_params", "pending_history_conversation", "current_article", "jump_assistant_params"].forEach(key => {
        sessionStorage.removeItem(key);
      });
    },
    isAspRoute(path) {
      return typeof path === "string" && path.startsWith("/asp");
    },
    markTokenReady() {
      window.tokenReady = true;
      window.dispatchEvent(new Event("tokenReady"));
      window.postMessage({ type: "token_updated" }, "*");
    },
    loadMainSidebarData() {
      if (this.mainSidebarDataLoaded) {
        return;
      }
      this.mainSidebarDataLoaded = true;
      if (localStorage.getItem("token")) {
        this.select_conversation_all();
      } else {
        // 未登录没有历史可查，也要广播一次，否则等待历史的一方会一直卡在"还在加载"。
        EventBus.$emit("conversationHistoryLoaded");
      }
      this.get_tool_list();
      this.user_display_name = getUserDisplayName();
      this.loadLoginOrgSysName();
    },
    loadLoginOrgSysName() {
      const sessionVersion = getAuthSessionVersion();
      const token = getMainToken();
      if (!token) {
        return Promise.resolve();
      }
      const cachedSysName = localStorage.getItem(LOGIN_ORG_SYS_NAME_CACHE_KEY);
      if (cachedSysName) {
        this.login_org_sys_name = cachedSysName;
      }
      if (this.loginOrgInfoLoaded) {
        return Promise.resolve(this.trialStatus);
      }
      if (this.loginOrgSysNamePromise) {
        return this.loginOrgSysNamePromise;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          token: token,
        },
      };
      const requestId = ++this.loginOrgSysNameRequestId;
      const request = this.$http
        .get(this.globalUrl.get_user_login_org_info, {}, config)
        .then(res => {
          if (requestId !== this.loginOrgSysNameRequestId || sessionVersion !== getAuthSessionVersion()) {
            return;
          }
          if (!res || res.code !== 1) {
            return;
          }
          const orgInfo = res.data;
          this.user_last_login_org = orgInfo && typeof orgInfo.name === "string" ? orgInfo.name : null;
          const sysName = orgInfo && orgInfo.extendAttrs && orgInfo.extendAttrs.jyx_sys_name;
          if (typeof sysName === "string" && sysName) {
            this.login_org_sys_name = sysName;
            localStorage.setItem(LOGIN_ORG_SYS_NAME_CACHE_KEY, sysName);
          }
          const schoolCode = orgInfo && orgInfo.extendAttrs && orgInfo.extendAttrs.jyx_code;
          if (schoolCode === undefined || schoolCode === null || String(schoolCode).trim() === "") {
            return;
          }
          return this.$http.get(this.globalUrl.get_trial_status, {
            params: { code: schoolCode },
          }).then(trialRes => {
            if (requestId !== this.loginOrgSysNameRequestId || sessionVersion !== getAuthSessionVersion()) {
              return;
            }
            this.schoolCode = String(schoolCode);
            this.trialStatus = trialRes;
            this.loginOrgInfoLoaded = true;
            return trialRes;
          });
        })
        .catch(() => {})
        .finally(() => {
          if (requestId === this.loginOrgSysNameRequestId) {
            this.loginOrgSysNamePromise = null;
          }
        });
      this.loginOrgSysNamePromise = request;
      return request;
    },
    resetLoginOrgBranding() {
      this.loginOrgSysNameRequestId += 1;
      this.loginOrgSysNamePromise = null;
      this.loginOrgInfoLoaded = false;
      this.trialStatus = null;
      this.schoolCode = "";
      localStorage.removeItem(LOGIN_ORG_SYS_NAME_CACHE_KEY);
      this.login_org_sys_name = DEFAULT_LOGIN_ORG_SYS_NAME;
      this.user_last_login_org = null;
    },
    ensureMicroAppTokenReady(options = {}) {
      if (this.microAppTokenPromise) {
        return this.microAppTokenPromise;
      }
      const forceRefresh = !!options.forceRefresh;
      const currentJyxToken = getMicroToken();
      if (currentJyxToken && !forceRefresh) {
        this.jyx_token = currentJyxToken;
        this.ipFlag = localStorage.getItem("ip_user") == 1 ? 1 : 0;
        this.user_display_name = getUserDisplayName();
        this.markTokenReady();
        return Promise.resolve(currentJyxToken);
      }

      window.tokenReady = false;
      this.jyx_token = "";
      const preparePromise = getMainToken() ? this.getUserInfo(false) : this.getIPUser(false);
      this.microAppTokenPromise = Promise.resolve(preparePromise).finally(() => {
        this.microAppTokenPromise = null;
      });
      return this.microAppTokenPromise;
    },
    // 提供给子应用调用的全局刷新 token 方法
    refreshToken() {
      if (this.microAppTokenPromise) {
        return this.microAppTokenPromise;
      }
      if (this.isRefreshingToken) {
        return Promise.resolve(getMicroToken());
      }
      this.isRefreshingToken = true;
      // ip_user 是缓存，不能用旧 IP 标记决定新主 token 的身份。
      const refreshPromise = getMainToken() ? this.getUserInfo(false) : this.getIPUser(false);
      this.microAppTokenPromise = Promise.resolve(refreshPromise)
        .then(() => getMicroToken())
        .finally(() => {
          this.isRefreshingToken = false;
          this.microAppTokenPromise = null;
        });
      return this.microAppTokenPromise;
    },
    checkIfMobile() {
      // 判断如果宽度发生了跨越断点的变化，或者在初始化时，才改变菜单状态
      if (window.innerWidth <= 1024) {
        this.left_bar_show_state = false;
      }
    },
    handleMessage(data) {
      // 配置请求 header
      const token = getMainToken();
      const config = {
        headers: {
          Authorization: token || "",
          token: token, // 兼容旧的 token 传递方式
        },
      };
      this.$http.post("/back/user_operate/update_user_display_name", { displayName: data.nickName }, config).then(() => {
        if (data.nickName) {
          this.user_display_name = data.nickName;
          setUserDisplayName(data.nickName);
        }
      });
    },
    getIPUser(loadMainData = true) {
      const sessionVersion = getAuthSessionVersion();
      const initialToken = getMainToken();
      const initialMicroToken = getMicroToken();
      return this.$http.post(this.globalUrl.oauth_ipLogin).then(res => {
        // 登录/退出期间的旧 IP 请求不能覆盖已经变化的会话。
        if (sessionVersion !== getAuthSessionVersion() || initialToken !== getMainToken() || initialMicroToken !== getMicroToken()) {
          return getMicroToken();
        }
        // 不是 IP 用户走统一登录
        if (res.code == 1) {
          if (res.data) {
            // 是 IP 用户，不走统一登录
            setMainToken(res.data.app_token);
            setUserDisplayName(res.user_display_name);
            // localStorage.setItem("user_visit_page_before_authorization", window.location.href); // 存储统一登录回调地址
            this.user_display_name = getUserDisplayName();
            setIpUserFlag(1);
            this.ipFlag = 1;

            this.jyx_token = getMainToken();
            setMicroToken(this.jyx_token);
            this.loadLoginOrgSysName();

            // 对于 IP 用户，因为不需要走 uniqueLogin，这里就是 token 准备完毕的时刻
            this.markTokenReady();
          } else {
            setMainToken("");
            clearMicroToken();
            this.jyx_token = getMainToken();
            this.activeNames = ["1"];

            // 没有登录也不是 IP 用户，直接放行，让子应用去处理登录拦截
            this.markTokenReady();

            if (loadMainData) {
              this.loadMainSidebarData();
            }
            return;
          }
          if (loadMainData) {
            this.loadMainSidebarData();
          }
        }
        return res;
      });
    },
    getUserInfo(loadMainData = true) {
      const sessionVersion = getAuthSessionVersion();
      const token = getMainToken();
      this.jyx_token = getMicroToken();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          token: token,
        },
      };
      return this.$http.get(this.globalUrl.get_user_info, {}, config).then(res => {
        if (sessionVersion !== getAuthSessionVersion()) {
          return getMicroToken();
        }
        const { ip_user, displayName } = res.data.user_info;
        this.loadLoginOrgSysName();
        setIpUserFlag(ip_user);
        if (ip_user == 1) {
          this.ipFlag = ip_user;
          return this.getIPUser(loadMainData);
        } else {
          this.ipFlag = 0;
          setUserDisplayName(displayName);

          const encrypted = encryptUserInfo(res.data.user_info.unionid);
          // get_user_info 可能通过 208 续期主 token，换票必须使用最新值。
          config.headers.Authorization = `Bearer ${getMainToken()}`;
          config.headers.token = getMainToken();
          return this.$http.post(this.globalUrl.getUniqueLoginToken, { unique: encrypted }, config).then(respone => {
            if (sessionVersion !== getAuthSessionVersion()) {
              return getMicroToken();
            }
            setMicroToken(respone.data);
            this.jyx_token = respone.data;

            // 通知主应用和子应用，token 已经更新完毕，可以发起请求或加载应用了
            this.markTokenReady();

            // 获取到 jyx_token 之后再调其他接口和加载后续逻辑
            if (loadMainData) {
              this.loadMainSidebarData();
            }
            return respone.data;
          });
        }
      });
    },

    openScholarlyService() {
      if (!this.scholarlyServiceEnabled || !this.schoolCode) {
        this.$message.warning("机构信息未就绪，请稍后重试");
        return;
      }
      // 仅普通登录追加自动登录参数，IP 登录不追加。
      const autoLoginQuery = getMainToken() && localStorage.getItem("ip_user") != 1 ? "&autoLogin=true" : "";
      window.open(`https://scholarly.cxstar.cn/?institution=${encodeURIComponent(this.schoolCode)}${autoLoginQuery}`, "_blank", "noopener,noreferrer");
    },
    jumpToUrl(url, index) {
      if (url === "/subjectGateway/index" && this.scholarlyServiceEnabled) {
        return this.openScholarlyService();
      }
      this.clearTopicAssistantSessionCache();
      if (!localStorage.getItem("token") && this.ipFlag !== 1) {
        this.authUtils.getOrgUrl().then(url => {
          window.location.href = url;
        });
      }

      const executeConversationLogic = (url, index) => {
        // 更新选中的导航索引
        this.selected_nav_index = index;
        this.cur_tool_idx = null;
        this.setStoredSelectedToolFunction(null);
        sessionStorage.setItem("chongda_menu_scroll_to_top_once", url);
        sessionStorage.setItem("chongda_skip_restore_once", url);
        sessionStorage.setItem("chongda_force_remount_path", url);
        sessionStorage.setItem("chongda_force_remount_nonce", String(Date.now()));
        this.scheduleResetAllPossibleScrollTops();
        // 文献服务平台
        if (localStorage.getItem("ip_user") == 1 && index == 3) {
          this.authUtils.getOrgUrl().then(url => {
            window.location.href = url;
          });
          return;
        }
        sessionStorage.removeItem("jump_assistant_params");
        // 如果跳转的是子应用相关路由，而且当前不是，则直接 pushState；如果是同一应用的不同子路由，也只推状态
        let targetPath = url;
        if (targetPath.includes("/asp/")) {
          this.left_bar_show_state = false;
        }

        history.pushState(null, "", targetPath);

        // 手动触发一次 PopStateEvent，让主应用和子应用的路由系统都能感知到变化
        const popStateEvent = new PopStateEvent("popstate", { state: null });
        window.dispatchEvent(popStateEvent);
        this.scheduleResetAllPossibleScrollTops();
      };

      // 直接导航，不要再做先跳 /home 的中转处理
      executeConversationLogic(url, index);
    },
    clossPaperAnalysis() {
      this.analysis_table_show_state = false;
    },
    // change_tool(idx) {
    //   this.cur_tool_idx = idx
    //   console.log(this.cur_tool_idx)
    //   // this.$emit('change_tool', this.cur_tool_idx)
    //   this.add_conversation(this.cur_tool_idx)
    // },
    // 请求功能列表
    get_tool_list() {
      this.$http.get(this.globalUrl.tool_list).then(res => {
        this.tool_list = res.data;
        const path = this.$route && this.$route.path ? this.$route.path : window.location.pathname;
        this.syncToolSelection(path);
        this.syncSelectedNavIndex(path);
        EventBus.$emit("toolListLoaded");
        this.ensureDefaultAcademicConversation();
      });
    },
    openZoteroBoard() {
      window.open("https://zotero.cxstar.cn/client/", "_blank", "noopener,noreferrer");
    },
    // 默认会话的唯一创建入口：LeftBar 拿到工具列表后和 Home 进入 /ai_home 时都走这里，
    // 两边各建一个会话会在"最近查询"里留下重复记录。
    ensureDefaultAcademicConversation() {
      // 增加判断：如果当前路由是 /oauth_loading 或者不是根目录 /ai_home 相关路径，不要自动创建新会话
      if (this.$route.path !== "/" && this.$route.path !== "/ai_home") return;
      // URL 上带着会话 id 时说明是刷新/直达某个会话，交给 Home 去恢复，不要新建。
      if (this.$route.query && this.$route.query.cid) return;
      if (this.default_conversation_pending) return;
      if (!Array.isArray(this.tool_list) || this.tool_list.length === 0) return;

      this.default_conversation_pending = true;
      const academicSearchToolIndex = this.getAcademicSearchToolIndex(this.tool_list);
      this.add_conversation(academicSearchToolIndex >= 0 ? academicSearchToolIndex : null, this.tool_list);
    },
    getWindowHeight(offset) {
      // 获取视口高度（不包括滚动条和工具栏）
      const windowHeight = window.innerHeight;

      // 获取 xk_collapse 和 tools_section 的高度
      const xkCollapse = document.querySelector(".xk_collapse");
      const toolsSection = document.querySelector(".tools_section");

      let xkHeight = 0;
      let toolsHeight = 0;

      if (xkCollapse) {
        xkHeight = xkCollapse.offsetHeight;
      }

      if (toolsSection) {
        toolsHeight = toolsSection.offsetHeight;
      }
      let remainingHeight;
      if (this.activeNames && this.activeNames.length == 1 && this.activeNames[0] === "2") {
        remainingHeight = windowHeight - xkHeight - toolsHeight - 220 + offset;
      } else if (this.activeNames && this.activeNames.length == 2 && this.activeNames[0] === "2") {
        remainingHeight = windowHeight - xkHeight - toolsHeight - 520 + offset;
      } else {
        remainingHeight = windowHeight - xkHeight - toolsHeight - 370 + offset;
      }
      return Math.max(remainingHeight, 200); // 最小高度 200px
    },
    // 跳转到文献检索页
    goToLiteratureSearch() {
      this.selected_nav_index = -1;
      this.setStoredSelectedToolFunction("word_segment_search");
      this.$router.push({ path: "/literatureSearch" }).catch(() => {});
    },
    handleTool(idx, tool_list, shouldClearTopicAssistantCache = true) {
      const selectedToolFunction = tool_list[idx] ? tool_list[idx]["function"] : null;
      if (!localStorage.getItem("token")) {
        this.authUtils.getOrgUrl().then(url => {
          window.location.href = url;
        });
        return;
      }
      this.selected_nav_index = -1;
      this.cur_tool_idx = idx;
      this.setStoredSelectedToolFunction(selectedToolFunction);
      this.add_conversation(idx, tool_list, shouldClearTopicAssistantCache);
    },
    // 创建新会话（新会话默认打开哪个工具，传入 tool_idx）
    add_conversation(tool_idx, tool_list, shouldClearTopicAssistantCache = false) {
      if (shouldClearTopicAssistantCache) {
        this.clearTopicAssistantSessionCache();
      }
      const executeConversationLogic = () => {
        this.selected_nav_index = -1;
        const currentToolFunction = tool_idx != null && tool_list[tool_idx] ? tool_list[tool_idx]["function"] : null;
        this.setStoredSelectedToolFunction(currentToolFunction);

        // 在创建新话题/切换功能时，如果是移动端或 iPad，则不展开侧边栏
        if (window.innerWidth > 1024) {
          this.left_bar_show_state = true;
        }

        // 文献检索
        if (tool_idx != null && currentToolFunction == "word_segment_search") {
          if (window) {
            history.pushState(null, "", "/literatureSearch");
            const popStateEvent = new PopStateEvent("popstate", { state: null });
            window.dispatchEvent(popStateEvent);
          }
        }
        // 论文分析
        if (tool_idx != null && currentToolFunction == "full_txt_art_analysis") {
          if (window) {
            history.pushState(null, "", "/asp/literature_analysis");
            const popStateEvent = new PopStateEvent("popstate", { state: null });
            window.dispatchEvent(popStateEvent);
          }
          if (window.innerWidth > 1024) this.left_bar_show_state = true;
          return;
        }
        if (tool_idx != null && currentToolFunction == "literature_review") {
          if (window) {
            history.pushState(null, "", "/asp/literature_review");
            const popStateEvent = new PopStateEvent("popstate", { state: null });
            window.dispatchEvent(popStateEvent);
          }
          if (window.innerWidth > 1024) this.left_bar_show_state = true;
          return;
        }
        if (tool_idx != null && currentToolFunction == "pdf_translation") {
          if (window) {
            history.pushState(null, "", "/asp/translation");
            const popStateEvent = new PopStateEvent("popstate", { state: null });
            window.dispatchEvent(popStateEvent);
          }
          if (window.innerWidth > 1024) this.left_bar_show_state = true;
          return;
        }
        if (tool_idx != null && currentToolFunction == "ai_help") {
          if (window) {
            history.pushState(null, "", "/AiHelp");
            const popStateEvent = new PopStateEvent("popstate", { state: null });
            window.dispatchEvent(popStateEvent);
          }
          return;
        }
        this.cur_tool_idx = tool_idx;
        if (!localStorage.getItem("token")) {
          this.cur_conversation_id = 1;
          this.default_conversation_pending = false;
          EventBus.$emit("change_conversation", this.cur_conversation_id, tool_idx, tool_list);
          EventBus.$emit("hideIframe");
        } else {
          this.$http
            .get(this.globalUrl.cxai_conversation_add)
            .then(res => {
              this.cur_conversation_id = res.data;
              this.default_conversation_pending = false;
              EventBus.$emit("change_conversation", this.cur_conversation_id, tool_idx, tool_list);
              EventBus.$emit("hideIframe");
            })
            .catch(() => {
              this.default_conversation_pending = false;
            });
        }
      };

      const currentPath = this.$route.path;
      const isNotHome = currentPath !== "/ai_home";

      if (currentPath === "/ai_home" && tool_idx != null && tool_list[tool_idx] && tool_list[tool_idx]["function"] === "topic_selection_assistance") {
        sessionStorage.setItem("topic_assistant_params", JSON.stringify({ tool_idx, tool_list }));
        this.$router.push({ path: "/topic-assistant" }).catch(() => {});
        return;
      }

      if (
        tool_idx != null &&
        (tool_list[tool_idx]["function"] == "literature_review" ||
          tool_list[tool_idx]["function"] === "pdf_translation" ||
          tool_list[tool_idx]["function"] == "topic_selection_assistance" ||
          tool_list[tool_idx]["function"] == "full_txt_art_analysis" ||
          tool_list[tool_idx]["function"] == "academic_search")
      ) {
        if (localStorage.getItem("ip_user") == 1) {
          this.authUtils.getOrgUrl().then(url => {
            window.location.href = url;
          });
          return;
        }
      }

      if (isNotHome) {
        const toolFunction = tool_idx != null ? tool_list[tool_idx]["function"] : null;
        const directRouteMap = {
          word_segment_search: "/literatureSearch",
          full_txt_art_analysis: "/asp/literature_analysis",
          topic_selection_assistance: "/topic-assistant",
          literature_review: "/asp/literature_review",
          pdf_translation: "/asp/translation",
          ai_help: "/AiHelp",
        };
        const targetPath = toolFunction ? directRouteMap[toolFunction] : null;

        if (targetPath && window) {
          history.pushState(null, "", targetPath);
          const popStateEvent = new PopStateEvent("popstate", { state: null });
          window.dispatchEvent(popStateEvent);
          return;
        }
        sessionStorage.setItem("topic_assistant_params", JSON.stringify({ tool_idx, tool_list }));
        this.$router.push({ path: "/ai_home" }).catch(() => {});
      } else {
        executeConversationLogic();
      }
    },
    // 切换会话
    change_conversation(conversation_id, tool_idx, tool_list) {
      this.cur_conversation_id = conversation_id;

      // 如果是文章分析，就在当前页渲染，否则加载对应会话
      // 使用事件总线触发会话切换事件
      // 第四个参数标记"这是已有会话"：本方法是历史记录点击和 URL 恢复的共同入口，
      // 打开的一定是有内容的旧会话，Home 据此让 ChatBox 直接按聊天态挂载，不闪欢迎页。
      // add_conversation 内部那两处 emit 是新建会话，不传这个标记。
      EventBus.$emit("change_conversation", conversation_id, tool_idx, tool_list, true);
      this.$emit("hideIframe"); // 切换会话时隐藏 iframe
    },
    // 历史记录事件
    history_conversation(conv, tool_list) {
      this.clearTopicAssistantSessionCache();
      const tool = conv.tool_idx != null ? tool_list[conv.tool_idx] : null;
      if (tool && tool["function"] == "full_txt_art_analysis") {
        sessionStorage.setItem(
          "full_txt_art_analysis_back_context",
          JSON.stringify({
            conversation_id: conv.conversation_id,
            tool_idx: conv.tool_idx,
            tool_list,
          }),
        );
        this.cur_conversation_id = conv.conversation_id;
        this.$emit("hideIframe");
        this.$router
          .push({
            path: "/full_txt_art_analysis_result",
            query: { conversation_id: String(conv.conversation_id) },
          })
          .catch(() => {});
        return;
      }
      const currentPath = this.$route.path;
      const isNotHome = currentPath !== "/ai_home";

      if (isNotHome) {
        const toolFunction = tool && tool["function"] ? tool["function"] : null;
        const historyRouteMap = {
          topic_selection_assistance: "/topic-assistant",
        };
        sessionStorage.setItem(
          "pending_history_conversation",
          JSON.stringify({
            conversation_id: conv.conversation_id,
            tool_idx: conv.tool_idx,
            tool_list,
          }),
        );
        this.$router.push({ path: historyRouteMap[toolFunction] || "/ai_home" }).catch(() => {});
      } else {
        this.change_conversation(conv.conversation_id, conv.tool_idx, tool_list);
      }
    },
    // 检索/刷新会话历史
    select_conversation_all() {
      this.$http.get(this.globalUrl.cxai_conversation_select_all).then(res => {
        // alert(res.data)
        this.conversation_history = res.data;
        // ChatBox 的"最近查询"通过 $refs 读这份数据，$refs 访问不会被 Vue 追踪为响应式
        // 依赖，computed 缓存后不会自动刷新，这里显式广播一下让它知道要重新取。
        EventBus.$emit("conversationHistoryLoaded");
        if (this.conversation_history.length == 0) {
          this.activeNames = ["1"]; // 收起历史记录，只展开科学导航
        }
        // // 渲染问题后，将滚动条滚到最底
        // this.scrollToBottom()
      });
    },
    // select_conversation_one() {
    //   this.$http.get(this.globalUrl.cxai_conversation_select_one, {params: {user_id: this.user_id, conversation_id: this.conversation_id}}).then(res => {
    //     // alert(res.data)
    //     this.academic_search___random_q = res.data
    //     // // 渲染问题后，将滚动条滚到最底
    //     // this.scrollToBottom()
    //   })
    // },
    hide_show_left_bar() {
      this.left_bar_show_state = !this.left_bar_show_state;
      this.getWindowHeight(0);
    },
    handleClick(tab, event) {
      void tab;
      void event;
    },
    // 个人中心
    tomyHome() {
      if (localStorage.getItem("ip_user") == 1 || !localStorage.getItem("token")) {
        this.authUtils.getOrgUrl().then(url => {
          window.location.href = url;
        });
        return;
      }

      const targetUrl = "/asp/self_setting";

      // 检查 window 存在且执行 qiankun 的 pushState 跳转逻辑
      if (window) {
        history.pushState(null, "", targetUrl);
        const popStateEvent = new PopStateEvent("popstate", { state: null });
        window.dispatchEvent(popStateEvent);
      }
    },
    executeLogout(showSuccessMessage = true) {
      const logoutUrl = "https://sso.cxstar.cn/logout";

      // 创建隐藏的 iframe 执行退出
      const ssoIframe = document.createElement("iframe");
      ssoIframe.style.cssText = "position:absolute;width:0;height:0;border:0;visibility:hidden;";
      ssoIframe.src = logoutUrl;
      document.body.appendChild(ssoIframe);

      // 使用 fetch 发送退出请求（更可靠）
      fetch(logoutUrl, { mode: "no-cors", credentials: "include" }).catch(() => {});

      // 清除本地登录状态，避免认证失败后继续加载微应用
      clearAllAuthTokens();
      localStorage.clear();
      window.tokenReady = false;
      this.resetLoginOrgBranding();
      this.mainSidebarDataLoaded = false;
      if (showSuccessMessage) {
        this.$message.success("退出成功");
      }

      setTimeout(() => {
        this.$router.replace({ path: "/literatureSearch" }).catch(() => {});
        // 重新走未登录逻辑，解决页面空白问题
        this.ipFlag = 0;
        this.jyx_token = null;
        this.user_display_name = "";
        this.getIPUser();
      }, 800);
    },
    logout() {
      this.$confirm("确定要退出登录吗?", "温馨提示", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.executeLogout();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.container_left {
  height: 100vh;
  transition: width 0.3s ease;
}

.sidebar_scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
}

.sidebar_scroll::-webkit-scrollbar {
  width: 6px;
}

.sidebar_scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.sidebar_scroll::-webkit-scrollbar-thumb:hover {
  background: #888;
}
/* CSS 变量定义 - 蓝色主题 */
:root {
  --primary-blue: #1a76d8;
  --primary-blue-dark: #0d5bb5;
  --primary-blue-light: #e8f0fe;
  --primary-blue-hover: #1565c0;
  --label-bg-hover: #e3f2fd;
  --bg-front: #f8f9fa;
}

/* 左侧栏整体样式优化 */
::v-deep .my_collapse.my_collapse {
  border-top: none;
  border-bottom: none;
}

::v-deep .my_collapse .el-collapse-item__wrap {
  border-bottom: none;
  background-color: transparent;
}

::v-deep .my_collapse .el-collapse-item__content {
  font-size: 14px;
  padding-bottom: 8px;
  border-left: 1px solid #0d5bb5;
  margin-left: 15px;
  padding-left: 6px;
  color: #666;
  background-color: none;
}

::v-deep .my_collapse .el-collapse-item__header {
  background-color: transparent !important;
  height: 40px;
  margin-top: 8px;
  font-weight: 600;
  color: #2c3e50;
  border-radius: 8px;
  transition: all 0.3s ease;
  border-bottom: 0px;
}

/* ::v-deep .my_collapse .el-collapse-item__header:hover {
  background-color: #f8f9fa !important;
} */

/* 确保父级容器能正确传递高度 */
::v-deep .el-tabs__content {
  height: 100%;
}

::v-deep .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 历史记录样式 */
.label_checked {
  cursor: pointer;
  padding: 5px 8px;
  /* background-color: var(--label-bg-hover); */
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  margin: 2px 0;
  color: #0d5bb5;
}

.common_label {
  cursor: pointer;
  padding: 5px 8px;
  background-color: none;
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  margin: 2px 0;
}
.common_label label {
  cursor: pointer;
}
.common_label:hover {
  background-color: none;
}

/* 新话题按钮样式 */
.new_conv {
  cursor: pointer;
  margin: 15px 0;
  color: #fff;
  border-radius: 8px;
  border: none;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 600;
  background: linear-gradient(135deg, #1a76d8 0%, #0d5bb5 100%);
  box-shadow: 0 4px 15px rgba(26, 118, 216, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.new_conv i {
  margin-right: 5px;
}
.new_conv:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(26, 118, 216, 0.4);
}

.new_conv2 {
  cursor: pointer;
  margin-left: 15px;
  color: #1a76d8;
  border-radius: 12px;
  border: 2px solid #1a76d8;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  background-color: #fff;
  transition: all 0.3s ease;
}
.new_conv2:hover {
  color: #fff;
  background-color: #1a76d8;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(26, 118, 216, 0.3);
}

/* 工具按钮样式 */
.tool_btn {
  padding: 8px;
  margin: 4px 0;
  color: #2c3e50;
  cursor: pointer;
  border-radius: 10px;
  /* border: 1px solid #e9ecef;
  background-color: #fff; */
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  font-weight: 500;
}
.mtop5 {
  padding: 2px 10px;
  margin: 6px 0;
}
.tool_btn:hover {
  color: #1a76d8;
  /* background-color: #f8f9fa; */
  /* border-color: #1a76d8; */
  /* transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */
}
.tool_btn:focus {
  outline: none;
}
.tool_btn_checked {
  color: #1a76d8;
}

/* 新增模板样式 */
.top_header {
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.user_org_info {
  border-radius: 8px;
  font-size: 13px;
  color: #0d5bb5;
  text-align: center;
  font-weight: 500;
}

.user_org_info i {
  margin-right: 8px;
  font-size: 16px;
}

.logo_area {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo_img {
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo_img:hover {
  transform: scale(1.1);
}

.logo_text {
  vertical-align: middle;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-left: 8px;
  transition: color 0.3s ease;
}

.logo_text:hover {
  color: #1a76d8;
}

.fold_icon {
  font-size: 22px;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 6px;
  border-radius: 6px;
}

.fold_icon:hover {
  color: #1a76d8;
  background-color: #f8f9fa;
}

.collapse_icon {
  margin-left: 10px;
  /* color: #1a76d8; */
}

.collapse_title {
  margin-left: 10px;
  font-weight: 600;
  color: #2c3e50;
}

.tool_name {
  margin-left: 10px;
}

.tools_section {
  margin: 10px 0;
}

.empty_history {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6c757d;
  font-size: 14px;
  text-align: center;
}

.empty_history i {
  margin-right: 8px;
  font-size: 18px;
  color: #adb5bd;
}

.user_info_section {
  height: 70px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #ffffff 0%, var(--primary-blue-light) 100%);
  border-top: 1px solid #e9ecef;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.user_avatar {
  margin-left: 0;
}

.contact_btn {
  border: none;
  background: transparent;
  color: #6c757d;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 12px;
  border-radius: 6px;
}

.contact_btn:hover {
  color: var(--primary-blue);
  background-color: #f8f9fa;
}

.tooltip_content {
  padding: 8px;
}

.tooltip_title {
  font-size: 15px;
  margin: 10px 0;
  font-weight: 600;
  color: #2c3e50;
}

.tooltip_desc {
  font-size: 12px;
  color: #6c757d;
}

.mini_sidebar {
  height: 100vh;
  width: 64px;
  /*position: absolute;*/
  top: 0;
  left: 0;
  background: #f7f9fc;
  box-shadow: 1px 0 0 rgba(15, 23, 42, 0.08);
  z-index: 100;
  display: flex;
  flex-direction: column;
}

.mini_sidebar_content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 8px;
}

.mini_logo {
  display: flex;
  justify-content: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 12px;
}

.mini_logo_img {
  width: 36px;
  height: 36px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.mini_logo_img:hover {
  transform: scale(1.1);
}

.mini_icon_list {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px 0;
}

.mini_icon_list::-webkit-scrollbar {
  width: 4px;
}

.mini_icon_list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.mini_icon_item {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 8px 0;
  cursor: pointer;
}

.mini_icon_wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mini_icon_wrapper i {
  font-size: 20px;
  color: #5a6c7d;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mini_icon_item:hover .mini_icon_wrapper {
  background-color: #e8f0fe;
}

.mini_icon_item:hover .mini_icon_wrapper i {
  color: #1a76d8;
  transform: scale(1.1);
}

.mini_icon_wrapper:active {
  transform: scale(0.95);
}

.mini_tooltip {
  position: absolute;
  left: 56px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  pointer-events: none;
}

.mini_tooltip::before {
  content: "";
  position: absolute;
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: #2c3e50;
}

.mini_icon_item:hover .mini_tooltip {
  opacity: 1;
  visibility: visible;
  left: 60px;
}

.mini_divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
  margin: 8px 4px;
}

.mini_user_section {
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.mini_avatar {
  overflow: hidden;
  border-radius: 50%;
  border: 2px solid #e8f0fe;
  transition: all 0.3s ease;
}

.mini_icon_item:hover .mini_avatar {
  border-color: #1a76d8;
  background-color: #fff;
}

.unfold_icon {
  font-size: 22px;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 6px;
  border-radius: 6px;
}

.unfold_icon:hover {
  color: var(--primary-blue);
  background-color: #f8f9fa;
  transform: rotate(-90deg);
}
.conv_span {
  cursor: pointer;
  padding: 3px 8px;
  background-color: rgba(59, 130, 246, 0.08);
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  color: #0d5bb5;
  margin: 4px 0;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}
.conv_span:hover {
  /* background-color: #e9ecef; */
  /* transform: translateY(-1px); */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
}
.slow_hide {
  /* 动画核心属性 */
  transition: all 0.3s ease;
  transform: translateX(100%);
  opacity: 0;
}
.slow_show {
  transition: all 0.3s ease;
  transform: translateX(0);
  opacity: 1;
}
.tab_title {
  font-size: 13px;
  text-overflow: inherit;
  color: var(--txt-color2);
  margin-top: 10px;
}

/* 针对 .chat_history_content 类优化滚动条 */
.chat_history_content {
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
  scrollbar-width: none;
  height: 220px;
}
.chat_history_content::-webkit-scrollbar {
  display: none;
}

.logout_img {
  display: flex;
  margin-left: 12px;
}
.logout_img img {
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.logout_img img:nth-of-type(2) {
  display: none;
}
.outlogin img {
  width: 17px;
}
.logout_img:hover > img:first-child {
  display: none !important;
}
.logout_img:hover > img:last-child {
  display: block;
}

.bottom_section {
  flex-shrink: 0;
  padding-bottom: 20px;
}

.contact_link {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: left;
  margin: 0 30px;
  padding: 10px 0;
  cursor: pointer;
  color: #555;
  font-size: 14px;
  transition: color 0.3s;

  i {
    margin-right: 8px;
    font-size: 16px;
  }

  &:hover {
    color: #1a76d8;
  }
}

.loginManager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin: 0 30px;
  margin-top: 15px;
  .el-icon-s-custom {
    margin-right: 5px;
    font-size: 16px;
    color: #555;
  }
  .loginName {
    cursor: pointer;
    display: flex;
    align-items: center;
    label {
      cursor: pointer;
    }
    .line1 {
      max-width: 110px;
      display: inline-block;
    }
  }
}
.loginManager .header {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccf0fc;
  margin-right: 10px;
  cursor: pointer;
  overflow: hidden;
}
.loginManager .header img {
  max-width: 30px;
  max-height: 30px;
  border-radius: 15px;
  cursor: pointer;
}
.loginManager .flex {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.logout_img {
  display: flex;
  margin-left: 12px;
}
.login_setting {
  display: flex;
}
</style>
